
import { Component, OnInit } from '@angular/core';
import { UploadedFileModel } from '../shared/models/fileupload.model';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
  images : UploadedFileModel [];
  user : any;
  constructor() { }

  ngOnInit() {

    this.images = new Array<UploadedFileModel>();
  }
  public uploadFinished = (event) => {
  
    if(event)
    {
      this.images.push(event);
    }

  }
}
